import "jquery";
import "bootstrap";
import "./Calendar";
import "./javascript/acsr.js"

import {Index} from "./Index";

$(() => {
    new Index();
});